<div class="box">
    <div class="box-title">
        {{ 'Documents' | translate }}

        <button mat-mini-fab
                color="none"
                class="more-button"
                [matTooltip]="'DocumentsAll' | translate"
                [routerLink]="'/' + organization?.code + '/athletes/' + athleteUser?.id + '/documents'"
        >
            <mat-icon color="primary">zoom_in</mat-icon>
        </button>

        <!--
        <button mat-mini-fab
                color="none"
                class="more-button float-right"
                (click)="openUploadDialog()">
            <mat-icon color="primary">cloud_upload</mat-icon>
        </button>
        -->
    </div>
    <div class="box-content">
        <mat-spinner *ngIf="isLoading; else boxContent" [diameter]="30"></mat-spinner>
    </div>
</div>

<ng-template #boxContent>
    <mat-list *ngIf="paginator.data.length > 0">
        <mat-list-item *ngFor="let document of paginator.data" class="document-list-item">
          <div class="list-content">
            <div class="text">
              <h3 matLine class="title">{{ document.originalName }}</h3>
              <p matLine class="date">
                  <span> {{ document.createDate|appDate:'mediumDate' }} </span>
              </p>
            </div>
            <button mat-icon-button class="button" (click)="download(document)">
                <mat-icon>cloud_download</mat-icon>
            </button>
          </div>
        </mat-list-item>
    </mat-list>

    <p *ngIf="paginator.data.length == 0">{{ 'DocumentNoData'|translate }}</p>
</ng-template>
